import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { SharedModule } from '../../shared/shared.module';
import { DireccionesGeograficasFormComponent } from './direcciones-geograficas/direcciones-geograficas-form/direcciones-geograficas-form.component';
import { EffectsModule } from '@ngrx/effects';
import { DepartamentosEffects } from './entity-departamentos/entity-departamentos.effects';
import { DireccionesGeograficaIDEEffects } from './entity-direcciones-geografica-ide/entity-direcciones-geografica-ide.effects';
import { LocalidadesEffects } from './entity-localidades/entity-localidades.effects';
import { PaisesEffects } from './entity-paises/entity-paises.effects';
import { GisModule } from '../../gis/gis.module';
import { DireccionesGeograficaIDEExactaEffects } from './entity-direcciones-geografica-ide-exacta/entity-direcciones-geografica-ide.effects';
import { LocalidadesIDEEffects } from './entity-localidades-ide/entity-localidades-ide.effects';

@NgModule({
  declarations: [DireccionesGeograficasFormComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    SharedModule,
    GisModule,
    EffectsModule.forFeature([
      DepartamentosEffects,
      DireccionesGeograficaIDEEffects,
      DireccionesGeograficaIDEExactaEffects,
      LocalidadesEffects,
      PaisesEffects,
      LocalidadesIDEEffects
    ])
  ],
  exports: [DireccionesGeograficasFormComponent]
})
export class UbicacionesModule {}
